import { styled } from "@woba/ds-web";
import { Variants } from "./button-label.types";

const variants: Variants = {
  variant: {
    label: {
      padding: "$space-02 $space-03",

      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "$neutral-200",

      transition: "0.2s",
      "&:hover": { background: "$neutral-100" },
    },
    medium: {
      padding: "$space-04 $space-03",

      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "$neutral-200",

      transition: "0.2s",
      "&:hover": {
        borderColor: "$neutral-700",
      },
    },
    link: {
      transition: "0.2s",
      "&:hover": {
        button: {
          color: "$neutral-900",
        },
      },
    },
  },
};

export const Wrapper = styled("div", {
  borderRadius: "$sm",
  backgroundColor: "transparent",
  width: "fit-content",

  fontWeight: "500",

  cursor: "pointer",
  variants,

  defaultVariants: {
    variant: "label",
  },
});
export const Button = styled("button", {
  all: "unset",
  display: "flex",
  alignItems: "center",

  fontSize: "$sm",
  color: "$neutral-700",

  a: {
    textDecoration: "none",
    fontSize: 14,
    color: "$neutral-700",
    fontWeight: "normal",
    "&:hover": { color: "$neutral-900" },
  },
});
